const defaultState = {

};

const acceptanceComponentReducer = (state = defaultState, action) => {
    
  switch (action.type) {
    case "SET_ACCEPTANCE_STATE":
      return {
        ...state,
        ...action.payload
      };
    default:
      return { ...state };
  }
};

export default acceptanceComponentReducer;
